import { DocumentMapping } from "@/configuration/document-mappings/types";
import { Classification } from "@/src/models/constants/classifications";

export const STRIDECARE_MAPPINGS: Partial<Record<Classification, DocumentMapping>> = {
  [Classification.ADMIN_DISABILITY_FORMS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "Disability forms",
    documentLabel: "Request for Additional Information",
    documentTypeId: 390522,
    folder: "Admin",
    folderMapping: "Admin",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ADMIN_DISABILITY_FORMS,
    group: "stridecare",
  },
  [Classification.CARE_PLAN]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "Plan of care",
    documentLabel: "Care Plan Oversight",
    documentTypeId: 394714,
    folder: "Physician Authorization",
    folderMapping: "Physician Authorization",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CARE_PLAN,
    group: "stridecare",
  },
  [Classification.CLEARANCE_REQUEST_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "Cardiac clearances",
    documentLabel: "Cardiac Clearance",
    documentTypeId: 309005,
    folder: "Clinical Document",
    folderMapping: "Clinical Document",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.CLEARANCE_REQUEST_RESPONSE,
    group: "stridecare",
  },
  [Classification.DME_ORDER]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "DME Order to be signed",
    documentLabel: "Care Plan Oversight",
    documentTypeId: 394714,
    folder: "Physician Authorization",
    folderMapping: "Physician Authorization",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.DME_ORDER,
    group: "stridecare",
  },
  [Classification.FINANCIAL_BILLING_RECORDS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Financial records",
    documentLabel: "Valerie Health - Financial Document",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.FINANCIAL_BILLING_RECORDS,
    group: "stridecare",
  },
  [Classification.IMAGING_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "All imaging results",
    documentLabel: "{{ type }}",
    folder: "Imaging/Diagnostic Result",
    folderMapping: "Imaging/Diagnostic Result",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.IMAGING_RESULTS,
    group: "stridecare",
  },
  [Classification.INSURANCE_CARD]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location prefix}needsvob",
    displayName: "Insurance fax back request (verification of benefits information)",
    documentLabel: "Explanation of Benefits",
    documentTypeId: 390183,
    folder: "Admin",
    folderMapping: "Admin",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.INSURANCE_CARD,
    group: "stridecare",
  },
  [Classification.LAB_RESULTS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "All lab results",
    documentLabel: "Lab*",
    documentTypeId: 400537,
    folder: "Lab Results",
    folderMapping: "Lab Results",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LAB_RESULTS,
    group: "stridecare",
  },
  [Classification.LEGAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Close Document"],
    assignedTo: null,
    displayName: "Power of attorney documents",
    documentLabel: "Health Care Power of Attorney",
    documentTypeId: 386202,
    folder: "Admin",
    folderMapping: "Admin",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.LEGAL,
    group: "stridecare",
  },
  [Classification.MEDICAL_RECORD_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "chartmatemedrec",
    displayName: "Medical record requests",
    documentLabel: "Medical Record Request",
    documentTypeId: 271399,
    folder: "Admin",
    folderMapping: "Admin",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST,
    group: "stridecare",
  },
  [Classification.MEDICAL_RECORD_REQUEST_HEDIS]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "chartmatemedrec",
    displayName: "medical_record_request_hedis",
    documentLabel: "Valerie Health Document",
    folder: null,
    folderMapping: null,
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.MEDICAL_RECORD_REQUEST_HEDIS,
    group: "stridecare",
  },
  [Classification.ORDER_IMAGING]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "Imaging orders",
    documentLabel: "{{ imagingType }}",
    folder: "Imaging/Diagnostic Result",
    folderMapping: "Imaging/Diagnostic Result",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_IMAGING,
    group: "stridecare",
  },
  [Classification.ORDER_LAB]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "Lab order that needs to be signed",
    documentLabel: "Care Plan Oversight",
    documentTypeId: 394714,
    folder: "Physician Authorization",
    folderMapping: "Physician Authorization",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.ORDER_LAB,
    group: "stridecare",
  },
  [Classification.PHARMACY_RELATED]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "Any Rx document",
    documentLabel: "",
    folder: "Clinical Document",
    folderMapping: "Clinical Document",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PHARMACY_RELATED,
    group: "stridecare",
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "Prior auths for medications",
    documentLabel: "",
    folder: "Clinical Document",
    folderMapping: "Clinical Document",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_REQUEST,
    group: "stridecare",
  },
  [Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "Prior auths for medications",
    documentLabel: "",
    folder: "Clinical Document",
    folderMapping: "Clinical Document",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_MEDICATION_RESPONSE,
    group: "stridecare",
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location prefix}submissionpending",
    displayName: "Insurance approvals for procedures ONLY not consults",
    documentLabel: "Request for additional information",
    documentTypeId: 390522,
    folder: "Admin",
    folderMapping: "Admin",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_REQUEST,
    group: "stridecare",
  },
  [Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location prefix}submissionpending",
    displayName: "Insurance approvals for procedures ONLY not consults",
    documentLabel: "Insurance {{ authorizationStatus }} - Procedure",
    folder: "Admin",
    folderMapping: "Admin",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PRIOR_AUTHORIZATION_PROCEDURE_RESPONSE,
    group: "stridecare",
  },
  [Classification.PROGRESS_NOTE]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: ["Close Document"],
    assignedTo: null,
    displayName: "Any progress note/medical history/etc",
    documentLabel: "Historical Medical Record",
    folder: "Medical Record Document - Historical Medical Record",
    folderMapping: "Medical Record Document - Historical Medical Record",
    inputDate: "",
    instructions: null,
    internalNote: "{{ location }} {{ providerName }}",
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE,
    group: "stridecare",
  },
  [Classification.PROGRESS_NOTE_OPERATIVE_REPORT]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "Operative or procedural reports",
    documentLabel: "Operative Report",
    documentTypeId: 342771,
    folder: "Clinic Document - Operative Report",
    folderMapping: "Clinic Document - Operative Report",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.PROGRESS_NOTE_OPERATIVE_REPORT,
    group: "stridecare",
  },
  [Classification.REFERRAL]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: null,
    displayName: "Referral",
    documentLabel: "Referral",
    documentTypeId: 391737,
    folder: "Admin",
    folderMapping: "Admin",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Inbound Referral WF",
    classification: Classification.REFERRAL,
    group: "stridecare",
  },
  [Classification.REFERRAL_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "Requesting a referral from StrideCare",
    documentLabel: "Request for Additional Information",
    documentTypeId: 390522,
    folder: "Admin",
    folderMapping: "Admin",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_REQUEST,
    group: "stridecare",
  },
  [Classification.REFERRAL_STATUS_REQUEST]: {
    accountFirstName: null,
    accountId: null,
    accountLastName: null,
    additionalWorkflow: null,
    assignedTo: "{location name} STAFF",
    displayName: "Update on referral StrideCare sent",
    documentLabel: "Referral Declined/Not Scheduled",
    documentTypeId: 390844,
    folder: "Admin",
    folderMapping: "Admin",
    inputDate: "",
    instructions: null,
    workflowAction: null,
    workflowType: "Standard",
    classification: Classification.REFERRAL_STATUS_REQUEST,
    group: "stridecare",
  },
} as const;
